/**
 * Modo de la ventana del renderer. La app corre en dos ventanas del mismo origen:
 *  - CONTROL (default): la UI del operador, con preview cosmético de la composición.
 *  - BROADCAST (`?mode=broadcast`): el OSR window oculto que renderiza la composición a la
 *    resolución de emisión y la encodea NVENC. No tiene UI ni operador mirándola.
 *
 * Helper puro y sin dependencias para que cualquier entidad (audio, Pixi, Radio) pueda saltar el
 * trabajo que en el OSR es muerto (monitor local, throttle por foco, siembra de paneles, etc.)
 * sin importar `controlBroadcast` (que arrastra Sentry y la config de encoders).
 */
export function isBroadcastWindow(): boolean {
  if (typeof window === "undefined") return false;

  return new URLSearchParams(window.location.search).get("mode") === "broadcast";
}
